<template>
<div class=searchBarFilter>
  <v-text-field :loading="loadingJourney.status" :disabled="loadingJourney.status" @change="setSearchBarText()"
    v-model="textSearchJourneyTitle" :aria-label="$t('searchJourney')" :label="$t('searchJourney')" single-line clearable
   @click:clear="cleartextSearchJourneyTitle" :placeholder="$t('searchJourney')" prepend-inner-icon="mdi-magnify"
    minlength="250px" class='mt-3' dense></v-text-field>
</div>
</template>
<script>
//import { mapState } from 'vuex';
export default ({
  name: 'searchBarFilterJourney',

  data: () => ({
    textSearchJourneyTitle:""
  }),
  computed: {
    loadingJourney: function(){
        return this.$store.getters.getLoadingJourney;
    }
  },
  mounted:  function () {
  },

  methods: {
    setSearchBarText() {
      if (this.textSearchJourneyTitle==null){
      this.textSearchJourneyTitle=""
      }
        this.$store.dispatch('setSearchBarTextValueJourney',this.textSearchJourneyTitle)
    },
    cleartextSearchJourneyTitle(){
        this.textSearchJourneyTitle = ""
        this.$store.dispatch('setSearchBarTextValueJourney',this.textSearchJourneyTitle)

    }
  }
})
</script>


<style>


.v-text-field input{
  min-width: 180px;
}

.searchBarFilter .theme--light.v-text-field > .v-input__control > .v-input__slot:before,
.searchBarFilter .theme--light.v-text-field > .v-input__control > .v-input__slot::after {
    border-color: transparent !important;
}
/*
.searchBarFilter div.v-input.expanding-search{
  transition: max-width 0.5s;
}
.searchBarFilter div.v-input.expanding-search.mt-3.closed{
max-width: 1rem;
}
*/

</style>